<section
  class="toggle-form"
  [ngClass]="{ active: isAssignmentGroupSliderOpen }"
>
  <div class="formwrap">
    <div class="Header">
      <h2>
        <b>{{ topBarTitle }}</b>
      </h2>
      <p-button
      appPreventDoubleClick
        styleClass="p-button-text"
        id="assignmentGroupSliderCloseButton"
        type="button"
        label="Close"
        (debounceClick)="closeSlider()"
      ></p-button>
    </div>
    <div class="general-container content">
      <app-create-assignment-group
        [assignmentGroupToEdit]="assignmentGroupToEdit"
      ></app-create-assignment-group>
    </div>
  </div>
</section>
